import React from 'react';
import AssessmentOverview from './AssessmentOverview';

export default function AssessmentOverviewByStudentRoute({ match }) {
	const studentId = match.params.student;
	if (studentId == null) return null; // TODO: replace by error

	return <AssessmentOverview studentId={studentId} />;
}
